import axios from 'axios';
import { setAlert } from './alert';
import {
    GET_SERVICES, ADD_SERVICE, SERVICE_ERROR
} from './types';

import { base_url } from './constants';

axios.defaults.baseURL = base_url;
//GET Categories
export const getServices = () => async dispatch => {
    try {
        const res = await axios.get('/api/services');
        dispatch({ type: GET_SERVICES, payload: res.data })
    } catch (err) {
        dispatch({
            type: SERVICE_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });
    }
}


export const createService = formData => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try {
        const res = await axios.post('/api/services/create', formData, config);
        dispatch({
            type: ADD_SERVICE,
            payload: res.data
        });

        dispatch(setAlert('Service Created', 'success'));


    } catch (err) {
        const errors = err.response.data.errors;
        console.log(errors);
        if (errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({
            type: SERVICE_ERROR,
        });
    }
}